module.exports = __webpack_public_path__ + "static/media/F.70802064.PNG";